<script lang="ts">
  import { onMount } from 'svelte';
  import AppShell from '../components/AppShell.svelte';
  import { fetchFunnels, type FunnelListItem } from '../lib/funnels-api';
  import { fmtPct } from '../lib/format';

  let items = $state<FunnelListItem[]>([]);
  let loading = $state(true);
  let err = $state<string | null>(null);

  onMount(async () => {
    try {
      items = await fetchFunnels();
    } catch (e) {
      err = e instanceof Error ? e.message : String(e);
    } finally {
      loading = false;
    }
  });
</script>

<AppShell active="funnels">
  <div class="mx-auto max-w-[1200px]">
    <header class="mb-5 flex items-end justify-between gap-3 flex-wrap">
      <div>
        <h1 class="text-2xl font-bold leading-tight">Воронки</h1>
        <p class="mt-1 text-[12px] text-[var(--color-text-muted)]">
          Стадії конфігуруються через Налаштування → Воронки
        </p>
      </div>
    </header>

    {#if loading}
      <div class="py-20 text-center text-sm text-[var(--color-text-muted)]">Завантаження…</div>
    {:else if err}
      <div class="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700">{err}</div>
    {:else}
      <div class="grid grid-cols-2 gap-3.5">
        {#each items as f (f.slug)}
          <div class="rounded-xl border border-[var(--color-border-3)] bg-white p-4 hover:border-[var(--color-pu-2)]">
            <div class="flex items-start justify-between mb-3">
              <div>
                <a href="#/funnels/{f.slug}/pipeline" class="text-[14px] font-bold no-underline hover:underline">{f.name}</a>
                <div class="text-[10px] text-[var(--color-text-muted)] mt-0.5">
                  slug: <code>{f.slug}</code> · {f.stages.length} стадій ·
                  {#if f.isActive}<span class="text-emerald-600 font-semibold">active</span>{:else}<span class="text-red-600 font-semibold">inactive</span>{/if}
                </div>
              </div>
              <div class="flex items-center gap-1.5 text-[11px] font-semibold">
                <a href="#/funnels/{f.slug}/pipeline" class="rounded-md bg-[var(--color-pu-light)] px-2.5 py-1 text-[var(--color-pu-3)] no-underline hover:bg-[var(--color-pu-1)]">Pipeline</a>
                <a href="#/funnels/{f.slug}" class="rounded-md border border-[var(--color-border-3)] px-2.5 py-1 text-[var(--color-text-muted)] no-underline hover:bg-[var(--color-bg-3)]">Статистика</a>
              </div>
            </div>
            <div class="mt-2 text-[11px] text-[var(--color-text-muted)] line-clamp-2">{f.description ?? ''}</div>
          </div>
        {/each}
        {#if items.length === 0}
          <div class="col-span-2 rounded-xl border border-dashed border-[var(--color-border-3)] bg-[var(--color-bg-2)] p-8 text-center text-sm text-[var(--color-text-muted)]">
            Немає воронок. Створіть через Settings → Воронки.
          </div>
        {/if}
      </div>
    {/if}
  </div>
</AppShell>
